import React from 'react';

import { TextField } from '@mui/material';
import Grid from '@mui/material/Grid';

import { type AnyItem, type AtolHotelItem, type EditableItem } from './atolEditHelpers';

interface AtolRoomFieldsEditorProps {
  editItem: EditableItem;
  isLoading: boolean;
  onUpdateField: (itemId: string, updater: (current: AnyItem) => AnyItem) => void;
}

export default function AtolRoomFieldsEditor({ editItem, isLoading, onUpdateField }: AtolRoomFieldsEditorProps) {
  const { groupKey, current } = editItem;

  if (groupKey !== 'hotels' && groupKey !== 'bedbankHotels') {
    return null;
  }

  const hotelItem = current as AtolHotelItem;
  const { rooms } = hotelItem;

  return (
    <Grid container spacing={2}>
      {rooms.map((room, roomIndex) => (
        <Grid size={{ xs: 12, sm: 6 }} key={room.roomId || roomIndex}>
          <TextField
            label={`Room ${roomIndex + 1}`}
            value={room.roomName}
            onChange={(e) => {
              const newName = e.target.value;
              onUpdateField(current.id, (currentItem) => {
                const clone = JSON.parse(JSON.stringify(currentItem)) as AtolHotelItem;
                clone.rooms[roomIndex] = { ...clone.rooms[roomIndex], roomName: newName };
                return clone;
              });
            }}
            fullWidth
            disabled={isLoading}
          />
        </Grid>
      ))}
    </Grid>
  );
}
